import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CommonTable } from "../../modules/common/table/Table";
import { orderDetailListColumns } from "../../modules/common/table/columns/_orderDetailListColumns";
import SharedPagination from "../../modules/common/sharedPagination";
import { FetchOrderDetailList } from "../../redux/features/dashboard/dashboardAction";
import { setCloseOrderListModal } from "../../redux/features/dashboard/dashboardSlice";

const OrderDetailModal = () => {
    const dispatch: any = useDispatch();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 10;

    const { openOrderListModal, modalListData, orderDetails, detailsTotalRecord } = useSelector(
        (state: any) => state.dashboardSlice
    );

    const orderDetailList = orderDetails?.items?.map(item => ({
        ...item,
        order_number: orderDetails.summary?.order_number,
        nearest_requested_date: orderDetails.summary?.nearest_requested_date,
    })) || [];

    const totalRecord = detailsTotalRecord || 0;
    const totalPages = Math.ceil(totalRecord / limit);


    useEffect(() => {
        if (openOrderListModal && modalListData?.order_number) {
            const fetchOrder = async () => {
                setLoading(true);
                try {
                    await dispatch(FetchOrderDetailList({
                        order_number: modalListData.order_number,
                        page: currentPage,
                        limit,
                    }));
                } catch (error) {
                    console.error("Failed to fetch order detail:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchOrder();
        }
    }, [openOrderListModal, modalListData, currentPage, dispatch]);

    const handleClose = () => dispatch(setCloseOrderListModal());
    const handlePageChange = (page: number) => setCurrentPage(page);

    return (
        <Modal className="detailModal" show={openOrderListModal} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Order Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="orderListTable">
                    {loading ? (
                        <p className="loading-text">Loading order details...</p>
                    ) : orderDetailList?.length > 0 ? (
                        <CommonTable data={orderDetailList} columns={orderDetailListColumns} />
                    ) : (
                        <p className="no-orders">No items available for this order.</p>
                    )}
                </div>

                {totalRecord > limit && (
                    <SharedPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}

            </Modal.Body>
        </Modal>
    );
};

export default OrderDetailModal;
